import React from 'react';
import { useParams } from 'react-router';

import { Divider } from 'antd';

import ContactChannel from '@/components/shared/ContactChannel';
import HelperCenter from '@/components/shared/HelperCenter';
import HelpForm from '@/components/shared/HelpForm';
import { useGetCourseQuery } from '@/services/course';
import styled, { StyledProp, css } from '@/styled';

const ContactTab = (props: StyledProp) => {
  const { hash } = useParams();
  const { data } = useGetCourseQuery(hash);

  return (
    <section className={props.className}>
      <ContactChannel courseId={data.id} />
      <Divider />
      <HelpForm courseHash={hash} courseTitle={data?.title} />
      <Divider />
      <HelperCenter />
    </section>
  );
};

export default styled(ContactTab)(
  ({ theme }) => css`
    .ant-space,
    .ant-select {
      width: 100%;
    }

    .ant-divider {
      margin-left: -16px;
      min-width: calc(100% + 32px);
      border-block-start: 1px solid ${theme.palette.gray[8]};
    }
  `
);
